import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	area__list: 'mw/admin/area/list',
	area__add: 'mw/admin/area/add',
	area__del: 'mw/admin/area/del',
};

export const areaApi = createApi({
	reducerPath: 'mw/admin/areaApi',

	endpoints: (builder) => ({
		areaList: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/area/list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.area__list],
		}),
		areaAdd: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/admin/area/add',
				body,
				jsonType: true,
			}),
			providesTags: [tags.area__add],
		}),
		areaDel: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/admin/area/del?${qs.stringify(body)}`,
				jsonType: true,
			}),
			providesTags: [tags.area__del],
		}),
	}),
});

export const {
	areaList,
	areaAdd,
	areaDel,
} = areaApi.endpoints;

export default areaApi;